import { ValueOf } from 'type-fest';

export const POINT_USE_TYPE = {
  ENABLED: 'enable',
  DISABLED: 'disable',
} as const;

export type PointUseType = ValueOf<typeof POINT_USE_TYPE>;
